export default __webpack_public_path__ + "assets/media/Top_Banner_MOB.0a65ca48.webp";